/* eslint-disable camelcase */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
// eslint-disable-next-line import/no-unresolved
import deviceImage from 'url:~/src/assets/DeviceImage1.png';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 12,
    color: '#1e3f9e',
    maxWidth: 650,
  },
}));

const Prepare = () => {
  const classes = useStyles();

  return (
    <div>
      <h4 className={classes.title}>
        Using a 1.3mm hex screwdriver, carefully open the back of the Neuralert Monitor by removing the 2 screws, then
        take the battery holder and circuit board out of the casing. Once this step is completed, click CONTINUE.
      </h4>
      <img src={deviceImage} alt="Monitor Diagram" />
    </div>
  );
};

export default Prepare;
